export default __webpack_public_path__ + "static/media/sendra-martorell.10c2e6fd.jpg";